import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'analytics/reports',
  size: 'full',
  children: {
    dashboards: {
      path: 'dashboards',
      children: {
        list: {
          size: 'full',
          path: 'list',
          children: {
            new: {
              size: 'full',
              path: 'new',
            },
          },
        },
        dashboardId: {
          size: 'full',
          level: 2,
          path: ':dashboard_id',
          children: {
            list: {
              size: 'full',
              level: 2,
              path: 'list',
              children: {
                edit: {
                  size: 'full',
                  level: 2,
                  path: 'edit',
                },
                delete: {
                  size: 'full',
                  level: 2,
                  path: 'delete',
                },
                question: {
                  size: 'full',
                  level: 2,
                  path: 'question',
                },
              },
            },
            new: {
              size: 'full',
              level: 3,
              path: 'new',
            },
            newSharedReport: {
              size: 'full',
              level: 3,
              path: 'new/:sharedReport',
            },
            templates: {
              size: 'full',
              level: 3,
              path: 'templates',
            },
            templatesTemplateSlug: {
              size: 'full',
              level: 3,
              path: 'templates/:template_slug',
            },
            templatesTemplateSlugSql: {
              size: 'full',
              level: 3,
              path: 'templates/:template_slug/sql',
            },
            sql: {
              size: 'full',
              level: 3,
              path: 'sql',
            },
          },
        },
      },
    },
    id: {
      path: ':id',
      size: 'full',
      level: 3,
      children: {
        edit: {
          size: 'full',
          level: 3,
          path: 'edit',
        },
        sqlEditor: {
          size: 'full',
          level: 3,
          path: 'sql_editor',
        },
        openSql: {
          size: 'full',
          level: 3,
          path: 'open_sql',
        },
        clone: {
          size: 'full',
          level: 3,
          path: 'clone',
        },
      },
    },
  },
} as const satisfies Location
